import React, { useState,useEffect } from 'react'
import { useAlert } from '../../../../context/AlertContext';
import kioskCheckinServices from '../kioskCheckinServices';

import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import moment from 'moment';

function ScheduleServiceSelectComponent( {selectedQueue, selectedService,setSelectedService, selectedDate,setSelectedDate, setActiveStep}) {

    const [queueServiceList,setQueueServiceList] = useState(null);
    const [availableSlots,setAvailableSlot] = useState(null);
    const {AppAlert} = useAlert();


    const getQueueServiceList = () =>{
        if(selectedQueue !== ""){
            kioskCheckinServices.getServiceListByQueueId(selectedQueue.id).then(res=>{
                setQueueServiceList(res.data);
                if(res.data.length === 1){
                    //selectQueueService(res.data[0]);
                }
            }).catch(error=>{
                AppAlert(error.msg,"error")
            })
        }
    }
    
    useEffect(()=>{
        getQueueServiceList()
    },[selectedQueue])


    const selectQueueService = (queueService) =>{
        setSelectedService(queueService);
        setActiveStep(2);
    }

    const getAvailableSlots = () =>{
        if(selectedQueue !== null && selectedDate !== null){
            setAvailableSlot(null);
            setQueueServiceList(null);
            let payload = {
                date: moment(selectedDate).format("YYYY-MM-DD"),
                queueId:selectedQueue.id,
            }
            kioskCheckinServices.getAvailableSlots(payload).then(res=>{
                setAvailableSlot(res.data.count);
                setQueueServiceList(res.data.queueServiceList);
            }).catch(error=>{
                AppAlert(error.msg,"error")
            })
        }
    }

    useEffect(()=>{
        getAvailableSlots();
    },[selectedDate])

    return (
        <div className='row'>
            <div className='col-md-6'>
                <Calendar 
                    onChange={setSelectedDate} 
                    value={selectedDate}
                    minDate={moment().add(1,"day").toDate()} 
                    maxDate={moment().add(selectedQueue.maxFutureDays,"day").toDate()}   
                />
            </div>

            <div className='col-md-6'>
                {availableSlots && queueServiceList &&
                    <div className='col-md-6'>
                            <div className='list-group rounded-0'>
                                <span className="list-group-item bg-primary text-white text-center">{availableSlots} Slots Available</span>
                                {queueServiceList && queueServiceList.map(queueService=>
                                    <button type="button" onClick={()=>selectQueueService(queueService)} class="list-group-item list-group-item-action">{queueService.title}</button>
                                )}
                            </div>
                            <div className='row'>
                                <div className='col-md-12'>
                                </div>
                            </div> 
                    </div>
                }
            </div>
            

        </div>
    )
}

export default ScheduleServiceSelectComponent